import { axiosPostRequest, getCommonRoute } from '../api';
import { config } from '../config';

const DOMAIN_URI_PREFIX = 'https://share.carecircle.org';

export const getSharableDynamicLink = ({
  url,
  socialTitle,
  socialDescription,
  socialImageLink,
}: {
  url: string;
  socialTitle: string;
  socialDescription?: string;
  socialImageLink?: string;
}): Promise<string> => {
  return axiosPostRequest(`${getCommonRoute()}/firebase/dynamicLink`, {
    dynamicLinkInfo: {
      domainUriPrefix: DOMAIN_URI_PREFIX,
      link: url,
      androidInfo: {
        androidPackageName: config.NX_PUBLIC_ANDROID_PACKAGE_NAME,
        androidFallbackLink: url,
      },
      iosInfo: {
        iosBundleId: config.NX_PUBLIC_IOS_BUNDLE_ID,
        iosAppStoreId: config.NX_PUBLIC_IOS_APP_STORE_ID,
        iosFallbackLink: url,
      },
      socialMetaTagInfo: {
        socialTitle,
        socialDescription,
        socialImageLink,
      },
      navigationInfo: {
        enableForcedRedirect: true,
      },
    },
    suffix: {
      option: 'UNGUESSABLE',
    },
  });
};
